import React, { useEffect, useRef } from 'react';

function Popup({ children, onClose, label="", className }) {
    const popupRef = useRef(null);

    // Auto-scroll when popup opens and extends below viewport
    useEffect(() => {
        if (popupRef.current) {
            // Increased timeout to ensure content is fully rendered
            setTimeout(() => {
                const popupRect = popupRef.current.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                
                // Check if ANY part of the popup goes below viewport (more sensitive)
                // Changed from -20 to +100 to catch cases where only small parts are hidden
                if (popupRect.bottom > viewportHeight - 100) {
                    // Find the parent button/trigger element
                    const trigger = popupRef.current.parentElement?.querySelector('button');
                    if (trigger) {
                        trigger.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        });
                    }
                }
            }, 200); // Increased delay to ensure popup content is fully rendered
        }
    }, []); // Runs once when popup mounts

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if click is on an Ant Design dropdown (which renders in a portal)
            const isAntDropdown = event.target.closest('.ant-select-dropdown') || 
                                 event.target.closest('.ant-picker-dropdown') ||
                                 event.target.closest('.ant-dropdown');
            
            // If clicking on Ant Design dropdown, don't close
            if (isAntDropdown) {
                return;
            }
            
            // Check if click is outside both the popup and its parent button
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                const parentButton = popupRef.current.parentElement?.querySelector('button:not(.absolute)');
                // Only close if click is not on the parent button either
                if (parentButton && !parentButton.contains(event.target)) {
                    onClose();
                }
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);
        
        // Cleanup
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    return (
        <div 
            ref={popupRef}
            className={`absolute left-0 mt-1 bg-white border border-gray-100 rounded-sm shadow-lg z-50 max-h-[400px] flex flex-col ${label === "Charge State" || label === "Charge City" ? "w-full" : "w-[90%]" }`}
        >
            {/* <div className="relative flex-shrink-0">
                <button
                    type="button"
                    className="absolute top-1 right-1 text-gray-500 hover:text-gray-700 text-xl z-10"
                    onClick={onClose}
                >
                    ×
                </button>
            </div> */}
            <div className={`overflow-y-scroll flex-1 px-2 w-auto min-w-[15rem] ${label !== "" ? "max-h-[22rem]" : "max-h-[28rem]"} no-scrollbar`}>
                {children}
            </div>
        </div>
    );
}

export default Popup;




